import React from 'react';


const stats = [
 
  {
    icon: 'bi bi-people-fill',
    number: '5,000+',
    label: 'Funds to choose from',
  },
  {
    icon: 'bi bi-coin',
    number: "FREE",
    label: 'Financial guidance / consultancy',
  },
  {
    icon: 'bi bi-person-badge-fill',
    number: 'SPOC',
    label: 'as your relationship manager',
  },
];

const WhyInvest = () => {
  return (
    <div className="why-taxnwealth py-5 text-center bg-light" >
      <div className="container wealth">
        <h2 className="fw-bold mb-5">Why invest with taxNwealth?</h2>
        <div className="row g-4 justify-content-center">
          {stats.map((item, index) => (
            <div className="col-6 col-md-3" key={index}>
              <div className="icon-box mb-3 fs-1 text-dark">
                <i className={item.icon}></i>
              </div>
              <h3 className="text-success fw-bold counter">{item.number}</h3>
              <p className="text-muted counter-txt">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyInvest;

